import React from 'react'

import Input from '../../common/components/Input'
import {validatePassword} from '../../common/common'

const PasswordInput = props => (
  <Input
    responsive
    label={props.label || "Password"}
    {...props}
    type="password"
    autoComplete="current-password"
    maxLength="256"
    value={props.password}
    onChange={props.onPasswordChange}
    paddingBottom={'padding-bottom: 36px'}
    required={props.required || true}
  />
)

PasswordInput.defaultProps = {validate: validatePassword}

export {PasswordInput as default}



// WEBPACK FOOTER //
// ./assets/auth/components/PasswordInput.js